import cx from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AgentStatus } from 'types/conversation'
import { uuid } from 'utils'

import './style.css'

export default function BotStatus({
  className = '',
  status = AgentStatus.OFFLINE,
}) {
  const { t } = useTranslation()

  const iconId = `botStatusTitle__${uuid()}`

  const statusText = (
    status === AgentStatus.ONLINE
      ? t('user.status.active')
      : status === AgentStatus.OFFLINE
        ? t('user.status.away')
        : ''
  )

  return (
    <svg
      aria-labelledby={iconId}
      className={cx(`bot-status bot-status--${status}`, {
        [className]: !!className
      })}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title id={iconId}>
        Drift agent status. Agent is currently {statusText}
      </title>
      <circle cx="10" cy="10" r="9" />
    </svg>
  )
}
